<template>
    <div style="width: 100%; height: 100%; overflow: auto;background-color: #eef1f4;">
        <el-container style="height:100%">
            <el-header style="padding: 0px; margin-bottom: 40px">
                <el-row style="height: 60px; line-height: 60px; background-color: #044578;">
                    <el-col :span="1" :offset="2" style="font-size: 30px;color: #ffffff">
                        <div style="width: 100%; height: 100%; cursor: pointer" @click="ret">
                            <i class="el-icon-arrow-left"></i>
                        </div>
                    </el-col>
                    <el-col :span="4"
                    style="text-align: left;
                            font-size: 18px;
                            color: #ffffff;
                            font-weight: bold;">
                        账号信息
                    </el-col>
                </el-row>
            </el-header>
            <el-main style="width: 100%">
                <!-- 经销商账号信息 -->
                <el-row style="width: 80%; margin: 0 auto">
                    <el-form
                        :model="user"
                        :rules="rules"
                        ref="customerForm"
                        label-width="120px"
                        label-position="right"
                        class="elFrom"
                        >
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="名称" prop="name">
                                    <el-input v-model="user.name" maxlength="20"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="主账号用户名" prop="username">
                                    <el-input v-model="user.username" maxlength="20" :disabled="true"></el-input>
                                </el-form-item>
                            </el-col>

                        </el-row>
                        <el-row>
                            <el-col :span="12" style="margin-bottom: 30px">
                                <el-form-item label="城市" prop="city">
                                    <el-input v-model="user.city"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="地址" prop="address">
                                    <el-input v-model="user.address"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-button type="success" @click="save">保存</el-button>
                        </el-row>
                    </el-form>
                </el-row>
                    <el-tabs style="height:calc(100% - 255px); width:80%;margin:30px auto">
      <el-tab-pane label="绑定项目" style="height:calc(100% - 70px)">
           <el-row style="width: 100%; margin: 30px;" >
                            <el-col :span="10" style="text-align: left;">
                                <el-input v-model="input" placeholder="输入需要绑定的14位主机序列号或手机号码" style="width: 80%" maxlength="14"></el-input>
                            </el-col>
                            <el-col :span="2" class="el-button2" style="margin-left: 15px">
                                <el-button type="success" @click="binding">绑定</el-button>
                            </el-col>
                        </el-row>
                        <el-row style="width: 100%; height:calc(100% - 70px)" >

                                <el-table
                                    :data="tableData1"
                                    stripe
                                    border
                                    :header-cell-style="{ 'text-align': 'center', 'background-color': '#f5f7fa' }"
                                    :cell-style="{ height: '45px', padding: '0', 'text-align': 'center' }"
                                    style="width: 100%; height:100%">
                                    <el-table-column
                                        type="index"
                                        label="序号"
                                        width="50">
                                    </el-table-column>
                                    <el-table-column
                                        prop="no"
                                        label="主机序列号">
                                    </el-table-column>
                                    <el-table-column
                                        prop="name"
                                        label="项目名称">
                                    </el-table-column>
                                    <el-table-column
                                        prop="unbind"
                                        label="操作">
                                        <template slot-scope="scope">
                                            <el-tooltip class="item" effect="dark" content="解绑" placement="bottom-start">
                                                <el-button type="info" size="mini" @click="unbind(scope.row)"><i class="el-icon-close"></i></el-button>
                                            </el-tooltip>
                                        </template>
                                    </el-table-column>
                                </el-table>

                        </el-row>
      </el-tab-pane>
      <el-tab-pane label="绑定子账号" style="height:calc(100% - 70px)">
           <el-row style="width: 100%; margin:30px">
                            <el-col :span="2" class="el-button2">
                                <el-button type="success" @click="binding_1">创建子账号</el-button>
                            </el-col>
                        </el-row>
                        <el-row style="width: 100%; height:calc(100% - 70px)" >

                                <el-table
                                    :data="tableData2"
                                    stripe
                                    border
                                    :header-cell-style="{ 'text-align': 'center', 'background-color': '#f5f7fa' }"
                                    :cell-style="{ height: '45px', padding: '0', 'text-align': 'center' }"
                                    style="width: 100%; height:100%">
                                    <el-table-column
                                        type="index"
                                        label="序号"
                                        width="50">
                                    </el-table-column>
                                    <el-table-column
                                        prop="username"
                                        label="用户名">
                                        <!-- <template slot-scope="scope">
                                            {{scope.row.username + '@' + user.username}}
                                        </template> -->
                                    </el-table-column>
                                    <el-table-column
                                        prop="name"
                                        label="昵称">
                                    </el-table-column>
                                    <el-table-column
                                        prop="level"
                                        label="子账号">
                                        <template slot-scope="scope">
                                            {{Level(scope.row.level)}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="createdtime"
                                        label="绑定时间">
                                    </el-table-column>
                                    <el-table-column
                                        prop="e"
                                        label="操作">
                                        <template slot-scope="scope" v-if="scope.row.level != 1">
                                            <el-tooltip class="item" effect="dark" content="编辑" placement="bottom-start">
                                                <el-button type="info" size="mini" @click="edit(scope.row)"><i class="el-icon-edit"></i></el-button>
                                            </el-tooltip>
                                            <el-tooltip class="item" effect="dark" content="删除" placement="bottom-start">
                                                <el-button type="info" size="mini" @click="del(scope.row)"><i class="el-icon-close"></i></el-button>
                                            </el-tooltip>
                                        </template>
                                    </el-table-column>
                                </el-table>

                        </el-row>
      </el-tab-pane>
  </el-tabs>
            </el-main>
        </el-container>
            <el-dialog
  title="请选择一个项目"
  :visible.sync="dialogVisible"
  width="55rem">
   <el-row style="height:30rem;overflow-y:auto">
      <el-card style="margin:10px;cursor:pointer" @click.native="selectProject(item)" class="box-card" v-for="item in projectList" :key="item.innerid">
        <div class="text item">
          {{item.name}}
        </div>
    </el-card>
   </el-row>
</el-dialog>
    </div>
</template>
<script>
import Vue from 'vue'
export default {
  name: 'DealerEdit',
  data () {
    return {
      dialogVisible: false,
      projectList: [],
      // 经销商账号信息
      tableData: [],
      tableData1: [],
      tableData2: [],
      user: {
        innerid: '',
        name: '',
        username: '',
        address: '',
        city: ''
      },
      input: '',
      where: {
        username: '',
        name: ''
      },
      activeName: 'first',
      label: 1,
      pageset: {num: 10, index: 1, item: 1},

      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }]
      }
    }
  },
  mounted: function () {
    var self = this
    let tableData = window.localStorage.getItem('edit')
    if (tableData) {
      self.tableData = JSON.parse(tableData)
      self.user.innerid = self.tableData.innerid
      self.user.name = self.tableData.name
      self.user.username = self.tableData.username
      self.user.address = self.tableData.address
      self.user.city = self.tableData.city
    } else {
      let tableData1 = window.localStorage.getItem('customer')
      self.tableData = JSON.parse(tableData1)
      self.user.innerid = self.tableData.dealerid
      self.user.name = self.tableData.dealername
      self.user.username = self.tableData.username
      self.user.address = self.tableData.address
      self.user.city = self.tableData.city
    }
    Vue.axios.post('/aio/dealer/project/list', {
      dealerid: self.user.innerid
    })
      .then((res) => {
        if (res.data.errcode == 0) {
          self.tableData1 = res.data.msgbody
        } else {
          self.$message({
            showClose: true,
            message: res.data.errmsg,
            type: 'error'
          })
        }
      })
    Vue.axios.post('/aio/dealer/account/list', {
      where: self.where,
      dealerid: self.user.innerid
    })
      .then((res) => {
        if (res.data.errcode == 0) {
          self.tableData2 = res.data.msgbody
          for (let i = 0; i < self.tableData2.length; i++) {
            if (self.tableData2[i].level != 1) {
              self.tableData2[i].username = self.tableData2[i].username + '@' + self.user.username
            }
          }
        } else {
          self.$message({
            showClose: true,
            message: res.data.errmsg,
            type: 'error'
          })
        }
      })
  },
  methods: {
    // 编辑经销商账号信息
    save () {
      var self = this
      Vue.axios.post('/aio/dealer/edit', {
        name: self.user.name,
        city: self.user.city,
        address: self.user.address,
        innerid: self.user.innerid
      })
        .then((res) => {
          if (res.data.errcode == 0) {
            self.$message({
              message: '修改成功',
              type: 'success'
            })
          } else {
            self.$message({
              message: '账号信息修改失败',
              type: 'error'
            })
          }
        })
    },
    // 绑定项目
    bangd1 () {
      var self = this
      self.label = 1
      console.log(self.label)
    },
    bangd2 () {
      var self = this
      self.label = 2
    },
    binding () {
      var self = this
      Vue.axios.post('/aio/dealer/project/queryByNo', {
        sn: self.input
      })
        .then((res) => {
          if (res.data.errcode == 0) {
            if (res.data.msgbody.length == 1) {
              self.selectProject(res.data.msgbody[0])
            } else {
              self.projectList = res.data.msgbody
              self.dialogVisible = true
            }
          } else {
            self.$message({
              showClose: true,
              message: res.data.errmsg,
              type: 'error'
            })
          }
        })
    },
    selectProject (project) {
      let self=this;
      Vue.axios.post('/aio/dealer/project/bind', {
        projectid: project.projectid,
        type: 1,
        dealerid: self.user.innerid
      })
        .then((res) => {
          if (res.data.errcode == 0) {
            Vue.axios.post('/aio/dealer/project/list', {
              dealerid: self.user.innerid
            })
              .then((res) => {
                if (res.data.errcode == 0) {
                  self.tableData1 = res.data.msgbody
                } else {
                  self.$message({
                    showClose: true,
                    message: res.data.errmsg,
                    type: 'error'
                  })
                }
              })
          } else {
            self.$message({
              showClose: true,
              message: res.data.errmsg,
              type: 'error'
            })
          }
        })
    },
    // 解绑项目
    unbind (row) {
      var self = this
      self.$confirm('确认要解绑项目？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          Vue.axios.post('/aio/dealer/project/bind', {
            type: 2,
            innerid: row.innerid
          })
            .then((res) => {
              if (res.data.errcode == 0) {
                Vue.axios.post('/aio/dealer/project/list', {
                  dealerid: self.user.innerid
                })
                  .then((res) => {
                    if (res.data.errcode == 0) {
                      self.tableData1 = res.data.msgbody
                    } else {
                      self.$message({
                        showClose: true,
                        message: res.data.errmsg,
                        type: 'error'
                      })
                    }
                  })
              } else {
                self.$message({
                  showClose: true,
                  message: res.data.errmsg,
                  type: 'error'
                })
              }
            })
        })
    },
    // 创建子账号
    binding_1 () {
      this.$router.push({ name: 'AccountAdd' })
    },
    // 删除子账号
    del (row) {
      let self = this
      self.$confirm('确认要删除此账号？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          Vue.axios.post('/aio/dealer/account/del', {
            innerid: row.innerid
          })
            .then((res) => {
              if (res.data.errcode == 0) {
                self.$message({
                  message: '删除成功',
                  type: 'success'
                })
                Vue.axios.post('/aio/dealer/account/list', {
                  where: self.where,
                  dealerid: self.user.innerid
                })
                  .then((res) => {
                    if (res.data.errcode == 0) {
                      self.tableData2 = res.data.msgbody
                    } else {
                      self.$message({
                        showClose: true,
                        message: res.data.errmsg,
                        type: 'error'
                      })
                    }
                  })
              } else {
                self.$message({
                  showClose: true,
                  message: res.data.errmsg || '删除失败',
                  type: 'error'
                })
              }
            })
        })
    },
    // 编辑子账号
    edit (row) {
      window.localStorage.setItem('AccountEdit', JSON.stringify(row))
      this.$router.push({ name: 'AccountAdd' })
    },
    Level (row) {
      let text = ''
      if (row == 1) {
        text = '主'
      } else {
        text = '子'
      }
      return text
    },
    // 返回
    ret () {
      this.$router.back()
    }
  }
}
</script>
<style scoped>
.elFrom >>> .el-form-item__label {
  color: #666666;
}
.bangding {
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-bottom: 0px;
    cursor: pointer
}
.bangding1 {
    color: aliceblue;
    background-color: #5daf34;
    border: 1px solid #5daf34;
}

.el-tabs__header{
  background: rgb(238, 241, 244) !important;
  border-bottom:0  !important;
}

.el-tabs__content{
  padding:0 !important;
  width:100%;
  background:rgb(238, 241, 244);
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/DealerEdit.vue